<template>
  <div class="profit">
    <progressBar
      class="profit-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <tips class="profit-tip">
      <div class="profit-tip__line"> 1. 以下为亚马逊预选商品的利润预算分析列表，当修改不同参数如采购价，物流费，销量，库存量，退货量等对照商品利润的实时变化，可使您更容易理解各项费用成本与利润的关系及产生的影响，这有利于您进行针对性的成本控制！ </div>
      <div class="profit-tip__line"> 2. 最关键的是您可在选品评估阶段对预选的商品进行“选品利润预算”，把关分析该商品盈利的可行性。</div>
      <div class="profit-tip__line"> 3. 甚至您也可以通过本系统录入竞争对手商品的售价，估计销量，库存量等数据信息，快速分析该竞争商品的利润区间！ </div>
    </tips>
    <div class="profit-top">
      <div class="profit-top__title">选品利润预算</div>
      <div class="profit-top__right">
        <div class="profit-top-item">
          <div class="profit-top-item__name">店铺:</div>
          <el-select v-model="searchData.store" size="mini"></el-select>
        </div>
        <div class="profit-top-item">
          <div class="profit-top-item__name">国家站点:</div>
          <el-select v-model="searchData.countrySite" size="mini"></el-select>
        </div>
        <div class="profit-top-item">
          <el-input v-model="searchData.text" size="mini" placeholder="请输入商品型号/名称/ASIN"></el-input>
        </div>
        <div class="profit-top__btn">搜索</div>
        <div class="profit-top__btn" @click="newProfitBtnClick">新建选品利润预算</div>
        <div class="profit-top__btn" @click="moreInfoBtnClick">查看更多信息</div>
      </div>
    </div>
    <div class="profti-table">
      <Table
        :head="profitTableType ? profitTableMoreHead : profitTableHead"
        :body="profitList"
        @deleteData="deleteTableData"
        @changeData="changeTableData"
        width="1654"
        height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ProfitSearchData, ProfitFromProductSelectNewModule, BudgetProfit } from './class'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
import ProfitAxios from 'service/profit'
export default {
  name: 'profitFromProductSelection',
  components: {
    progressBar, tips, Table
  },
  data(){
    return {
      /**进度条数据 */
      progressData: ProfitFromProductSelectNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 3,
      /**搜索数据 */
      searchData: new ProfitSearchData(),
      /**表头 */
      profitTableHead: ProfitFromProductSelectNewModule.NEWTABLEHEAD(),
      profitTableMoreHead: ProfitFromProductSelectNewModule.NEWTABLEMOREHEAD(),
      profitList: [],
      profitTableType: 0
    }
  },
  methods: {
    /**新建选品利润预算 */
    newProfitBtnClick(){
      this.$emit('go', {
        id: 'newProfitFromProductSelection',
        name: '新建选品利润预算',
      })
    },
    /**获取选品利润预算列表 */
    async getProfitList(bool = false){
      let res = await ProfitAxios.getProductBudgetList(this.searchData.getSearchAxiosBody)
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      if(bool) this.$message.success('查询成功')
      let list = res.data.info
      this.profitList.splice(0, this.profitList.length)
      list.map(l => {
        let profitData = new BudgetProfit()
        profitData.backendListDataParsing(l)
        console.log(profitData);
        this.profitList.push(profitData)
      })
    },
    /**删除数据 */
    async deleteTableData(index){
      let id = this.profitList[index].id
      let res = await ProfitAxios.deleteProductBudget(id)
      if(res.data.code === 1){
        this.$message.success(res.data.info)
        this.profitList.splice(index, 1)
      }else{
        this.$message.error(res.data.info)
      }
    },
    /**修改数据 */
    changeTableData(index){
      this.$emit('go', {
        id: 'newProfitFromProductSelection',
        name: this.profitList[index].name,
        index: index,
        obj: {
          type: 'change',
          id: this.profitList[index].budgetId,
          value: JSON.stringify(this.profitList[index])
        }
      })
    },
    /**查看更多信息 */
    moreInfoBtnClick(){
      this.profitTableType = (this.profitTableType + 1) % 2
    }
  },
  mounted(){
    this.getProfitList(true)
  },

}
</script>

<style lang="scss" scoped>
.profit{
  width: 1800px;
  &-progress{
    margin-bottom: 5px;
  }
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__title{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__right{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      &__name{
        font-size: 14px;
        padding: 0 5px;
      }
    }
    &__btn{
      min-width: 100px;
      text-align: center;
      margin-left: 10px;
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
      color: white;
      background: #00a0c7;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
